// LGPD-compliant privacy policy (Lei 13.709/2018) — PT canonical, EN/FR courtesy.
// Controller: Lionel · npdlbr.com.br · contato: lionel@npdlbr.com.br

export const PRIVACY = {
  pt: {
    title: "Política de Privacidade",
    overline: "LGPD · Lei nº 13.709/2018",
    lastUpdate: "Última atualização: 10 de fevereiro de 2026",
    intro:
      "Esta política explica, de forma direta, como a Na Ponta Da Língua Brasil coleta, usa e protege os seus dados pessoais. Está em conformidade com a Lei Geral de Proteção de Dados Pessoais do Brasil (LGPD).",
    sections: [
      {
        h: "1. Quem é o controlador dos seus dados",
        p: [
          "O controlador é Lionel Philippe, professor titular do site Na Ponta Da Língua Brasil (npdlbr.com.br), pessoa física residente no Brasil.",
          "Para qualquer dúvida ou solicitação relativa aos seus dados, basta escrever para <strong>lionel@npdlbr.com.br</strong>. Respondo pessoalmente em até 24 horas úteis.",
        ],
      },
      {
        h: "2. Quais dados a gente coleta",
        p: [
          "Apenas o que você nos envia voluntariamente pelo formulário de contato ou pelo teste de nível:",
        ],
        ul: [
          "Nome completo e (opcionalmente) como prefere ser chamado(a).",
          "E-mail e telefone (este último é opcional).",
          "Nível atual de francês, objetivo principal e mensagem livre.",
          "Resultado e respostas do teste de nível, quando você decide fazê-lo.",
          "Idioma do site no qual você navegou (PT, EN ou FR) — útil para te respondermos no mesmo idioma.",
          "Dados técnicos anônimos via PostHog (páginas visitadas, cliques em botões, sem identificação pessoal) — usados apenas para entender o que funciona ou não no site.",
        ],
      },
      {
        h: "3. Para que usamos os dados",
        p: ["Estritamente para:"],
        ul: [
          "Entrar em contato com você sobre a aula gratuita ou as aulas pagas que você solicitou.",
          "Enviar a sua confirmação automática por e-mail (resposta imediata após o envio do formulário).",
          "Ajustar o conteúdo do site, com base em estatísticas anônimas do PostHog (nunca individualizadas).",
        ],
        pAfter:
          "Não enviamos newsletters, propagandas ou mensagens não solicitadas. Você só recebe e-mails relacionados à conversa que você iniciou.",
      },
      {
        h: "4. Com quem compartilhamos",
        p: [
          "Com <strong>ninguém</strong>, exceto os provedores técnicos estritamente necessários para o site funcionar:",
        ],
        ul: [
          "<strong>MongoDB Atlas</strong> — banco de dados onde seus dados ficam armazenados, com criptografia em repouso.",
          "<strong>Resend</strong> — serviço utilizado apenas para transmitir os e-mails (não armazena o conteúdo dos seus dados).",
          "<strong>PostHog</strong> — analytics comportamental, sem identificação pessoal direta.",
        ],
        pAfter:
          "Nunca vendemos, alugamos ou cedemos seus dados a terceiros para fins comerciais.",
      },
      {
        h: "5. Base legal (art. 7º da LGPD)",
        p: [
          "Tratamos seus dados com base no <strong>consentimento</strong> que você nos dá ao enviar o formulário, e no <strong>legítimo interesse</strong> para responder à sua solicitação.",
        ],
      },
      {
        h: "6. Por quanto tempo guardamos",
        p: [
          "Mantemos seus dados pelo tempo necessário para a finalidade da coleta — em geral, enquanto durar a relação de aulas, ou até que você solicite a exclusão.",
          "Após a solicitação de exclusão, removemos seus dados em até 7 dias úteis, exceto quando houver obrigação legal de retenção.",
        ],
      },
      {
        h: "7. Os seus direitos (art. 18 da LGPD)",
        p: [
          "Você pode, a qualquer momento, exercer os seguintes direitos enviando um e-mail para <strong>lionel@npdlbr.com.br</strong>:",
        ],
        ul: [
          "Confirmar que tratamos seus dados.",
          "Acessar uma cópia dos dados que armazenamos sobre você.",
          "Corrigir dados incompletos, inexatos ou desatualizados.",
          "Anonimizar, bloquear ou eliminar dados desnecessários ou excessivos.",
          "Solicitar a portabilidade dos seus dados a outro fornecedor.",
          "Solicitar a eliminação completa dos seus dados.",
          "Revogar o consentimento dado a qualquer momento.",
        ],
        pAfter:
          "Atendemos qualquer uma dessas solicitações em até 15 dias, sem custo.",
      },
      {
        h: "8. Cookies e rastreamento",
        p: [
          "O site usa um único serviço de analytics — <strong>PostHog</strong> — que registra cliques e páginas visitadas de forma anônima, sem associação direta com o seu nome ou e-mail. Não há cookies publicitários nem rastreamento por terceiros.",
          "Se preferir não ser rastreado, você pode bloquear PostHog pelo seu navegador (todas as funcionalidades do site continuam funcionando normalmente).",
        ],
      },
      {
        h: "9. Segurança",
        p: [
          "Os dados são armazenados em servidores com criptografia em repouso e trafegam apenas via HTTPS. O acesso administrativo é protegido por senha forte e autenticação JWT. Em caso de qualquer incidente, você será notificado por e-mail no mesmo dia.",
        ],
      },
      {
        h: "10. Mudanças nesta política",
        p: [
          "Se atualizarmos esta política, alteramos a data no topo desta página. Mudanças relevantes serão comunicadas por e-mail aos alunos ativos.",
        ],
      },
      {
        h: "11. Como exercer seus direitos / Encarregado de Dados (DPO)",
        p: [
          "Encarregado pelo tratamento de dados pessoais: <strong>Lionel Philippe</strong> · <a href='mailto:lionel@npdlbr.com.br'>lionel@npdlbr.com.br</a>",
          "Você também pode apresentar reclamação à Autoridade Nacional de Proteção de Dados (ANPD), em <a href='https://www.gov.br/anpd' target='_blank' rel='noopener noreferrer'>gov.br/anpd</a>.",
        ],
      },
    ],
    consentMicro:
      "Ao enviar, você concorda com a <a href='/privacidade' class='underline hover:text-[#1e2a5a]'>Política de Privacidade</a>. Seus dados são usados apenas para contato sobre as aulas e nunca compartilhados com terceiros.",
    footerLink: "Política de Privacidade",
    backHome: "← Voltar para o site",
  },

  en: {
    title: "Privacy Policy",
    overline: "Brazilian LGPD · Law 13.709/2018",
    lastUpdate: "Last updated: February 10, 2026",
    intro:
      "This policy explains, in plain language, how Na Ponta Da Língua Brasil collects, uses and protects your personal data. It complies with the Brazilian General Data Protection Law (LGPD).",
    sections: [
      {
        h: "1. Who controls your data",
        p: [
          "The data controller is Lionel Philippe, the teacher behind Na Ponta Da Língua Brasil (npdlbr.com.br), a natural person based in Brazil.",
          "For any question or request about your data, just write to <strong>lionel@npdlbr.com.br</strong>. I reply personally within 24 working hours.",
        ],
      },
      {
        h: "2. What data we collect",
        p: ["Only what you voluntarily send via the contact form or the level test:"],
        ul: [
          "Full name and (optionally) the name you prefer to be called by.",
          "Email and phone (phone is optional).",
          "Current French level, main goal and free-text message.",
          "Level-test answers and result, when you choose to take it.",
          "The site language you browsed in (PT, EN or FR) — so we reply in the same language.",
          "Anonymous technical data via PostHog (visited pages, button clicks, no personal identification) — used only to understand what works on the site.",
        ],
      },
      {
        h: "3. What we use the data for",
        p: ["Strictly to:"],
        ul: [
          "Contact you about the free class or paid classes you requested.",
          "Send you the automated confirmation email (instant reply after you submit the form).",
          "Tune the site, based on anonymous PostHog analytics (never individualised).",
        ],
        pAfter:
          "We don't send newsletters, ads or unsolicited messages. You only get emails related to the conversation you started.",
      },
      {
        h: "4. Who we share it with",
        p: [
          "<strong>Nobody</strong>, except the technical providers strictly needed for the site to work:",
        ],
        ul: [
          "<strong>MongoDB Atlas</strong> — database where your data is stored, with encryption at rest.",
          "<strong>Resend</strong> — used only to transmit the emails (does not store the content of your data).",
          "<strong>PostHog</strong> — behavioural analytics, without direct personal identification.",
        ],
        pAfter:
          "We never sell, rent or hand over your data to third parties for commercial purposes.",
      },
      {
        h: "5. Legal basis (art. 7 of the LGPD)",
        p: [
          "We process your data based on the <strong>consent</strong> you give when submitting the form, and on the <strong>legitimate interest</strong> to reply to your request.",
        ],
      },
      {
        h: "6. How long we keep it",
        p: [
          "We keep your data for as long as needed for the purpose of collection — typically while we have an active teaching relationship, or until you ask for deletion.",
          "After a deletion request, we erase your data within 7 working days, except where the law requires retention.",
        ],
      },
      {
        h: "7. Your rights (art. 18 of the LGPD)",
        p: [
          "At any moment, you can exercise the following rights by writing to <strong>lionel@npdlbr.com.br</strong>:",
        ],
        ul: [
          "Confirm that we process your data.",
          "Access a copy of the data we store about you.",
          "Correct incomplete, inaccurate or out-of-date data.",
          "Anonymise, block or delete unnecessary or excessive data.",
          "Request portability to another provider.",
          "Request full deletion of your data.",
          "Withdraw your consent at any time.",
        ],
        pAfter: "We honour any of these requests within 15 days, at no cost.",
      },
      {
        h: "8. Cookies and tracking",
        p: [
          "The site uses a single analytics tool — <strong>PostHog</strong> — that records clicks and visited pages anonymously, with no direct link to your name or email. There are no advertising cookies and no third-party tracking.",
          "If you prefer not to be tracked, you can block PostHog in your browser (all site features keep working normally).",
        ],
      },
      {
        h: "9. Security",
        p: [
          "Data is stored on servers with encryption at rest and transmitted only via HTTPS. Admin access is protected by a strong password and JWT authentication. In case of any incident, you'll be notified by email the same day.",
        ],
      },
      {
        h: "10. Changes to this policy",
        p: [
          "If we update this policy, the date at the top of this page changes. Material changes are communicated by email to active students.",
        ],
      },
      {
        h: "11. Exercising your rights / Data Protection Officer (DPO)",
        p: [
          "Data protection officer: <strong>Lionel Philippe</strong> · <a href='mailto:lionel@npdlbr.com.br'>lionel@npdlbr.com.br</a>",
          "You may also file a complaint with the Brazilian Data Protection Authority (ANPD), at <a href='https://www.gov.br/anpd' target='_blank' rel='noopener noreferrer'>gov.br/anpd</a>.",
        ],
      },
    ],
    consentMicro:
      "By submitting, you agree to the <a href='/privacidade' class='underline hover:text-[#1e2a5a]'>Privacy Policy</a>. Your data is used only to contact you about the lessons and never shared with third parties.",
    footerLink: "Privacy Policy",
    backHome: "← Back to the site",
  },

  fr: {
    title: "Politique de confidentialité",
    overline: "LGPD brésilienne · Loi nº 13.709/2018",
    lastUpdate: "Dernière mise à jour : 10 février 2026",
    intro:
      "Cette politique explique, en langage clair, comment Na Ponta Da Língua Brasil collecte, utilise et protège vos données personnelles. Elle est conforme à la Loi générale brésilienne sur la protection des données (LGPD).",
    sections: [
      {
        h: "1. Qui contrôle vos données",
        p: [
          "Le responsable du traitement est Lionel Philippe, professeur titulaire du site Na Ponta Da Língua Brasil (npdlbr.com.br), personne physique résidant au Brésil.",
          "Pour toute question ou demande concernant vos données, écrivez à <strong>lionel@npdlbr.com.br</strong>. Je réponds personnellement sous 24 heures ouvrables.",
        ],
      },
      {
        h: "2. Quelles données nous collectons",
        p: ["Uniquement ce que vous nous transmettez volontairement via le formulaire de contact ou le test de niveau :"],
        ul: [
          "Nom complet et, au choix, le prénom par lequel vous préférez être appelé(e).",
          "E-mail et téléphone (le téléphone est facultatif).",
          "Niveau actuel de français, objectif principal et message libre.",
          "Réponses et résultat du test de niveau, si vous décidez de le passer.",
          "Langue du site dans laquelle vous avez navigué (PT, EN ou FR) — pour vous répondre dans la même langue.",
          "Données techniques anonymes via PostHog (pages consultées, clics sur les boutons, sans identification personnelle) — utilisées uniquement pour comprendre ce qui fonctionne sur le site.",
        ],
      },
      {
        h: "3. À quoi servent les données",
        p: ["Strictement à :"],
        ul: [
          "Vous contacter à propos du cours d'essai ou des cours payants que vous avez demandés.",
          "Vous envoyer la confirmation automatique par e-mail (réponse immédiate après l'envoi du formulaire).",
          "Ajuster le site, à partir de statistiques anonymes PostHog (jamais individualisées).",
        ],
        pAfter:
          "Nous n'envoyons pas de newsletters, publicités ou messages non sollicités. Vous ne recevez que des e-mails liés à la conversation que vous avez initiée.",
      },
      {
        h: "4. Avec qui nous partageons",
        p: [
          "Avec <strong>personne</strong>, à l'exception des prestataires techniques strictement nécessaires au fonctionnement du site :",
        ],
        ul: [
          "<strong>MongoDB Atlas</strong> — base de données où vos données sont stockées, avec chiffrement au repos.",
          "<strong>Resend</strong> — utilisé uniquement pour transmettre les e-mails (ne stocke pas le contenu de vos données).",
          "<strong>PostHog</strong> — analytics comportemental, sans identification personnelle directe.",
        ],
        pAfter:
          "Nous ne vendons, ne louons ni ne cédons jamais vos données à des tiers à des fins commerciales.",
      },
      {
        h: "5. Base légale (art. 7 de la LGPD)",
        p: [
          "Nous traitons vos données sur la base du <strong>consentement</strong> que vous donnez en envoyant le formulaire et de l'<strong>intérêt légitime</strong> à répondre à votre demande.",
        ],
      },
      {
        h: "6. Durée de conservation",
        p: [
          "Nous conservons vos données aussi longtemps que nécessaire à la finalité de la collecte — en général, le temps de la relation pédagogique, ou jusqu'à votre demande de suppression.",
          "Après une demande de suppression, nous effaçons vos données sous 7 jours ouvrables, sauf obligation légale de conservation.",
        ],
      },
      {
        h: "7. Vos droits (art. 18 de la LGPD)",
        p: [
          "Vous pouvez à tout moment exercer les droits suivants en écrivant à <strong>lionel@npdlbr.com.br</strong> :",
        ],
        ul: [
          "Confirmer que nous traitons vos données.",
          "Accéder à une copie des données que nous stockons sur vous.",
          "Corriger des données incomplètes, inexactes ou obsolètes.",
          "Anonymiser, bloquer ou supprimer des données inutiles ou excessives.",
          "Demander la portabilité de vos données vers un autre prestataire.",
          "Demander la suppression intégrale de vos données.",
          "Retirer votre consentement à tout moment.",
        ],
        pAfter: "Nous répondons à toute demande sous 15 jours, sans frais.",
      },
      {
        h: "8. Cookies et suivi",
        p: [
          "Le site utilise un seul outil d'analytics — <strong>PostHog</strong> — qui enregistre clics et pages visitées de manière anonyme, sans lien direct avec votre nom ou e-mail. Pas de cookies publicitaires, pas de tracking tiers.",
          "Si vous préférez ne pas être suivi, vous pouvez bloquer PostHog depuis votre navigateur (toutes les fonctionnalités du site continuent de marcher normalement).",
        ],
      },
      {
        h: "9. Sécurité",
        p: [
          "Les données sont stockées sur des serveurs avec chiffrement au repos et transitent uniquement via HTTPS. L'accès administrateur est protégé par mot de passe fort et authentification JWT. En cas d'incident, vous serez notifié par e-mail le jour même.",
        ],
      },
      {
        h: "10. Modifications de cette politique",
        p: [
          "Si nous mettons cette politique à jour, la date en haut de la page change. Les modifications importantes sont communiquées par e-mail aux élèves actifs.",
        ],
      },
      {
        h: "11. Exercer vos droits / Délégué à la protection des données (DPO)",
        p: [
          "Délégué à la protection des données : <strong>Lionel Philippe</strong> · <a href='mailto:lionel@npdlbr.com.br'>lionel@npdlbr.com.br</a>",
          "Vous pouvez également déposer une plainte auprès de l'Autorité brésilienne de protection des données (ANPD) : <a href='https://www.gov.br/anpd' target='_blank' rel='noopener noreferrer'>gov.br/anpd</a>.",
        ],
      },
    ],
    consentMicro:
      "En envoyant, vous acceptez la <a href='/privacidade' class='underline hover:text-[#1e2a5a]'>Politique de confidentialité</a>. Vos données ne servent qu'à vous contacter au sujet des cours et ne sont jamais partagées avec des tiers.",
    footerLink: "Politique de confidentialité",
    backHome: "← Retour au site",
  },
};
